module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('ui-title-red', {
    attrs: {
      "textTitle": "  Presupuesto mensual: Gastos opcionales"
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Presupuesto mensual',
      "videoEmbed": "ADMINISTRACIONDINERO34PresupuestoMensualGastosOcasionales.mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-4": ""
    }
  }, [_c('p', [_vm._v("\n        Para determinar sus gastos opcionales complete los siguientes cuadros:"), _c('br'), _vm._v("\n        Importante: Digite las cifras sin puntos ni comas\n      ")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('ui-calculadora', {
    attrs: {
      "formulario": _vm.gastosVariables,
      "nombresCols": _vm.nombres,
      "resultadoDiferencia": _vm.resultadoDiferencia,
      "resultadoTotal": _vm.resultadoTotal
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5907807c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-34.vue
// module id = 1005
// module chunks = 1